
import {
    Bars3Icon,
    ChevronDownIcon
} from '@heroicons/react/24/outline';
import { useEffect, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DataContext } from '../../../../context/DataContext';

const Navbar = ({ turnToHidden, signOut }) => {
    const { userData } = useContext(DataContext);
    const [isActive, setIsActive] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (userData?.attributes) {
            setUserInfo(userData.attributes);
        }
    }, [userData]);

    const handleMenuToggle = () => setIsActive((prev) => !prev);

    return (
        <nav className="w-full green-app-bg h-20 flex items-center justify-between px-8 text-white">
            <div className="flex items-center gap-3">
                <Bars3Icon onClick={turnToHidden} className="w-6 h-6 cursor-pointer lg:hidden" />
                <Link to="/chatroom" className="text-white font-bold text-xl">SincronyBot</Link>
                <div className="hidden md:flex ml-8 items-center space-x-6 text-sm">
                    <Link to="/chatroom" className="hover:text-gray-100">Mi chat</Link>
                    <Link to="/suscripccion" className="hover:text-gray-100">Suscripciones</Link>
                </div>
            </div>

            <div className="flex items-center gap-4 text-sm">
                <span className="hidden lg:block">{userInfo?.name || ''}</span>
                <div className="relative inline-block text-left">
                    <button
                        className="px-2 py-1 rounded-full border border-white/30 flex items-center gap-2 hover:border-white/60"
                        onClick={handleMenuToggle}
                    >
                        <div
                            className="h-8 w-8 rounded-full bg-gray-300"
                            style={{ backgroundImage: `url('https://picsum.photos/20/20')` }}
                            aria-hidden="true"
                        />
                        <ChevronDownIcon className="w-3 h-3" />
                    </button>

                    <div
                        className={`absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${
                            isActive ? 'block' : 'hidden'
                        }`}
                        role="menu"
                        aria-orientation="vertical"
                        tabIndex="-1"
                    >
                        <div className="py-1" role="none">
                            <button
                                onClick={() => navigate('/profile')}
                                className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 w-full text-left"
                                role="menuitem"
                            >
                                Mi perfil
                            </button>
                            <button
                                onClick={signOut}
                                className="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 w-full text-left"
                                role="menuitem"
                            >
                                Cerrar sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
